__turbopack_context__.v({
  "actions": "study-error-client-module__ahhpzG__actions",
  "body": "study-error-client-module__ahhpzG__body",
  "button": "study-error-client-module__ahhpzG__button",
  "errorWrap": "study-error-client-module__ahhpzG__errorWrap",
  "eyebrow": "study-error-client-module__ahhpzG__eyebrow",
  "link": "study-error-client-module__ahhpzG__link",
  "title": "study-error-client-module__ahhpzG__title",
});
